export default {
	BILL: '帳單',
	CONTRACT: '合約',
	PAYMENT: '繳款',
	COLLECTION_PAYMENT: '加購/代收代付',
	SETTING: '設定',
	ACCOUNT_MANAGEMENT: '帳戶管理',
	SERVICE: '服務',
	BASIC_SERVICE: '基本服務設定',
	ROAMING: '國際漫遊',
	INTERNET_MANAGEMENT: '上網管理',
	QUICK_RESTART: '快速復話',
	RING: '音樂鈴聲',
};




// WEBPACK FOOTER //
// ./src/store/breadCrumb.js